import navbar1 from "../../pages/react/navbars/navbar1/navbar1.png"
import navbar2 from "../../pages/react/navbars/navbar2/navbar2.png"
import navbar3 from "../../pages/react/navbars/navbar3/navbar3.png"

import accordion1 from "../../pages/react/accordions/accordion1/accordion1.png"

import tab1 from "../../pages/react/tabs/tab1/tab1.png"
import tab2 from "../../pages/react/tabs/tab2/tab2.png"

import menu1 from "../../pages/react/menus/menu1/menu.png"

import testemonial1 from "../../pages/react/testemonials/testemonial1/testemonial1.png"
import testemonial2 from "../../pages/react/testemonials/testemonial2/testemonial2.png"

import modal1 from "../../pages/react/modals/modal1/modal1.png"

import darkmode from "../../pages/react/projects/darkmode1/darkmode.png"
import loremipsum from "../../pages/react/projects/loremipsum/loremipsum.png"
import quiz from "../../pages/react/projects/quiz/quiz.png"
import markdown from "../../pages/react/projects/markdown/markdown.png"

const items = [
  {
    id: 15,
    title: "Quiz",
    category: "Projects",
    img: quiz,
    desc: `quiz app`,
    urlLink: "/react/projects/quiz/",
  },
  {
    id: 1,
    title: "Navbar 1",
    category: "Navbars",
    img: navbar1,
    desc: `Navbar element`,
    urlLink: "/react/navbars/navbar1/",
  },

  {
    id: 3,
    title: "Accordion 1",
    category: "Accordions",
    img: accordion1,
    desc: `Accordion element`,
    urlLink: "/react/accordions/accordion1/",
  },
  {
    id: 4,
    title: "Tabs 1",
    category: "Tabs",
    img: tab1,
    desc: `Accordion element`,
    urlLink: "/react/tabs/tab1/",
  },
  {
    id: 5,
    title: "Testemonial1",
    category: "Testemonials",
    img: testemonial1,
    desc: `Review element for react`,
    urlLink: "/react/testemonials/testemonial1/",
  },
  {
    id: 6,
    title: "Testemonial2",
    category: "Testemonials",
    img: testemonial2,
    desc: `Review element for react`,
    urlLink: "/react/testemonials/testemonial2/",
  },

  // {
  //   id: 7,
  //   title: "Testemonial2 v2",
  //   category: "Testemonials",
  //   img: testemonial2,
  //   desc: `Review element for react`,
  //   urlLink: "/react/testemonials/testemonial2/Alternative",
  // },

  {
    id: 8,
    title: "Navbar with modal",
    category: "Navbars",
    img: navbar2,
    desc: `Navbar side  element for react`,
    urlLink: "/react/navbars/navbar2/",
  },

  {
    id: 10,
    title: "Modal",
    category: "Modals",
    img: modal1,
    desc: `Modal example`,
    urlLink: "/react/modals/modal1/",
  },

  {
    id: 9,
    title: "Dark Mode",
    category: "Projects",
    img: darkmode,
    desc: `Dark mode in React`,
    urlLink: "/react/projects/darkmode1/",
  },

  {
    id: 11,
    title: "Navbar 3",
    category: "Navbars",
    img: navbar3,
    desc: `Strapi Navbar element`,
    urlLink: "/react/navbars/navbar3/",
  },

  {
    id: 12,
    title: "Restorant Menu",
    category: "Menu",
    img: menu1,
    desc: `menu item with categories`,
    urlLink: "/react/menus/menu1/",
  },

  {
    id: 13,
    title: "Lorem Ipsum Generator",
    category: "Projects",
    img: loremipsum,
    desc: `Macedonian lorem ipsum || Carl Sagan Quotes Lorem Ipsum `,
    urlLink: "/react/projects/loremipsum/",
  },

  {
    id: 14,
    title: "Tabs 2",
    category: "Tabs",
    img: tab2,
    desc: `Tab element`,
    urlLink: "/react/tabs/tab2/",
  },

  {
    id: 16,
    title: "Markdown",
    category: "Projects",
    img: markdown,
    desc: `Markdown editor `,
    urlLink: "/react/projects/markdown/",
  },
]

export default items
